<style lang="less">
  @import "~$views/less/var.less";
  .hex-head{
    text-align: center;
    color: @font_color;
    margin-bottom: 0;
    font-size: @font_size_lg;
    font-weight: 500;
    height:@head_height;
    line-height: @head_height;
    margin-right: 2px;
    width: 100%;
    flex: none;
    position: relative;
    background:#fff;
    box-sizing: border-box;
    &--right{
      position: absolute;
      right: 8px;
      font-size:12px;
      color: #999 !important;
      cursor: pointer;
      user-select: none;
      .ant-checkbox-wrapper {
        color: #999;
      }
      button span{
        color: #fff !important;
      }
      button[disabled] span{
        color: inherit !important;
      }
      i, span.level{
        margin-left: 0 !important;
        color: #999 !important;
        font-style: normal;
      }
    }
    &.level1{
      .hex-title{
        padding-left: 12px;
      }
    }
  }
  .hex-title{
    margin-left: 16px;
  }
</style>
<template>
  <div class="hex-head">
    <span class="hex-title"><slot></slot></span>
    <span class="hex-head--right">
      <slot name="right"></slot>
    </span>
  </div>
</template>
<script>
export default {
}
</script>
